import { createSlice } from "@reduxjs/toolkit";
const unsetList = ['' , null , undefined , 'any']
const initialState = {
    data: {},
    page: 1,
    pageLimit: 25,
    totalData: 999999999999,
    agreementInfo: {},
    rentalInfo: {},
    invoiceInfo: {},
    invoicePageLimit : 10 ,
    rentalFilters : {},
    agreementFilters : {},
    eventFilters:{},
    tenantFilters : {},
    invoiceFilters:{},
    events : { data : {} , currentPage : 1},
    eventInfo : {},
    eventAgreements : {},
    tenants:{},
    leads:{},
    leadsFilters:{},
    preload:{},
    loader : false
  }
export const rentSlice = createSlice({
  name: "rent",
  initialState: initialState,
  reducers: {

    setLoader:(state,action)=>{
      state.loader = action.payload
    },
    setRentalFilters:(state, action)=>{
      if(unsetList.indexOf(action.payload.value) > -1){
        delete state.rentalFilters[action.payload.key]
        return
      }
      state.rentalFilters[action.payload.key] = action.payload.value

    },
    setTenantFilters : (state,action)=>{
      if(unsetList.indexOf(action.payload.value) > -1){
        delete state.tenantFilters[action.payload.key]
        return
      }
      state.tenantFilters[action.payload.key] = action.payload.value
    },
    setLeadsFilters : (state,action)=>{
      if(unsetList.indexOf(action.payload.value) > -1){
        delete state.leadsFilters[action.payload.key]
        return
      }
      state.leadsFilters[action.payload.key] = action.payload.value
    },
    setEventFilters : (state,action)=>{
      if(unsetList.indexOf(action.payload.value) > -1){
        delete state.eventFilters[action.payload.key]
        return
      }
      state.eventFilters[action.payload.key] = action.payload.value
    },
    setAgreementFilters:(state, action)=>{
      if(unsetList.indexOf(action.payload.value) > -1){
        delete state.agreementFilters[action.payload.key]
        return
      }
      state.agreementFilters[action.payload.key] = action.payload.value
    },
    setInvoiceFilters:(state, action)=>{
      if(unsetList.indexOf(action.payload.value) > -1){
        delete state.rentalFilters[action.payload.key]
        return
      }
      state.invoiceFilters[action.payload.key] = action.payload.value

    },
    setDataByPage: (state, action) => {

      state.data[state.page] = action.payload;
    },
    setTotalData: (state, action) => {
      state.totalData = action.payload;
    },
    setRentAgreements: (state, action) => {

      var page = action.payload.page;
      state.agreementInfo[page] = action.payload.data;
      state.agreementInfo["currentPage"] = action.payload.page;
      if (action.payload.total)
        state.agreementInfo["totalData"] = action.payload.total;
    },
    setTenantsInfo:(state,action)=>{
      var page = action.payload.page;
      state.tenants[page] = action.payload.data;
      state.tenants["currentPage"] = action.payload.page;
      if (action.payload.total && state.tenants.totalData === undefined)
        state.tenants["totalData"] = action.payload.total;
    },
    setLeadsInfo: (state, action) => {
      var page = action.payload.page;
      state.leads[page] = action.payload.data;
      state.leads["currentPage"] = action.payload.page;
      if (action.payload.total && state.leads.totalData === undefined)
        state.leads["totalData"] = action.payload.total;
    },
    setMessage:(state,action)=>{
      state.message = action.payload

    },
    setEventsInfo:(state,action)=>{
      var page = action.payload.page;
      if (action.payload.data.length){
      state.events.data[page] = action.payload.data;
      state.events["currentPage"] = action.payload.page;
      }
      if (action.payload.total )
        state.events["totalData"] = action.payload.total;
    },
    clearRentInfo: (state, action) => {

      for(var key of Object.keys(initialState)){
        if (!(key.endsWith('Filters') || key.endsWith('loader') ))
        state[key] = initialState[key]
      }

    },
    clearAgreementInfo:(state,action)=>{
      state.agreementInfo = {}
      state.invoiceInfo = {}
    },
    clearTenantsInfo:(state)=>{
      state.tenants = {}
    },
    clearLeadsInfo: (state) => {
      state.leads = {};
    },
    clearEventsInfo:(state)=>{
      state.events = { data : {} , currentPage : 1}
    },
    setInvoiceInfo: (state, action) => {
      if (!(action.payload.agreementId in state.invoiceInfo)) {
        state.invoiceInfo[action.payload.agreementId] = { currentPage: 1 };
        if(state.invoiceInfo[action.payload.agreementId]['total'] === undefined){
        state.invoiceInfo[action.payload.agreementId]["total"] =
        action.payload.total;
        }
      }  else {
        state.invoiceInfo[action.payload.agreementId]['currentPage'] = action.payload.page
      }
      state.invoiceInfo[action.payload.agreementId][action.payload.page] =
        action.payload.data;

    },

    resetPageData: (state, action) => {
      var payloadData = action.payload;
      if (payloadData?.action == "set") {
        state.data[payloadData?.page] = payloadData?.data;
      }
      if (payloadData?.action == "delete") {
        delete state.data[payloadData.page];
      }
      if (payloadData?.action == "reset") {
        state.data[payloadData.page] = state.data[payloadData.fromPage];
      }
    },
    setRentalInfo: (state, action) => {
      state.rentalInfo = action.payload;
    },
    setEventInfo:(state,action)=>{
      state.eventInfo = action.payload
    },
    setEventAgreements:(state,action)=>{
      state.eventAgreements['data'] = {}
      if (action.payload.data){
      state.eventAgreements.data[action.payload.page] = action.payload.data
      state.eventAgreements['currentPage'] = action.payload.page

        state.eventAgreements['total'] = action.payload.totalRecords
      }

    } ,
    setEventExtras:(state,action)=>{

        state.eventInfo['extras'] = action.payload

    }
  },
});

export const {
  setEventExtras,
  setInvoiceInfo,
  setDataByPage,
  clearRentInfo,
  setRentAgreements,
  resetPageData,
  setTotalData,
  setRentalInfo,
  setEventsInfo,
  setEventInfo,
  setLeadsInfo,
  setRentalFilters,
  setAgreementFilters,
  setInvoiceFilters ,
  clearEventsInfo,
  setEventAgreements,
  setTenantFilters,
  setLeadsFilters,
  setEventFilters,
  setTenantsInfo,
  clearTenantsInfo,
  clearLeadsInfo,
   clearAgreementInfo,
   setLoader,
   setMessage,
   setPreload
} = rentSlice.actions;
export default rentSlice.reducer;
